import { REQUEST, RESPONSE, CLEAR, FAILURE } from '../../actions/blueprints/detail';

const initialState = {
  response: null,
  isLoading: false,
  error: null
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case RESPONSE:
      return {
        ...state,
        // The API envelope is {data: {model: {...}}} for every branch of
        // GET /models/<uid> (regular, foundation, public).
        response: action.payload.model,
        isLoading: false,
        error: null
      };
    case CLEAR:
      return initialState;
    case FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};
